import RoutesMap from "route_control/RouteControl"
import { ProductList, AddProduct, UpdateProduct, ProductDetails, ProductReviews, PricingList, PricingConfiguration, RecipeList, RecipeDetails } from "pages/product_management"

const ProductManagementRoute = () => {
    return [
        {
            path: RoutesMap.PRODUCT_LIST.path,
            element: <ProductList />
        },
        {
            path: RoutesMap.ADD_PRODUCT.path,
            element: <AddProduct />
        },
        {
            path: RoutesMap.UPDATE_PRODUCT.path,
            element: <UpdateProduct />
        },
        {
            path: RoutesMap.PRODUCT_DETAILS.path,
            element: <ProductDetails />
        },
        {
            path: RoutesMap.PRODUCT_REVIEWS.path,
            element: <ProductReviews />
        },

        {
            path: RoutesMap.PRICING_LIST.path,
            element: <PricingList />
        },
        {
            path: RoutesMap.PRICING_CONFIGURATION.path,
            element: <PricingConfiguration />
        },

        {
            path: RoutesMap.RECIPE_LIST.path,
            element: <RecipeList />
        },
        {
            path: RoutesMap.RECIPE_DETAILS.path,
            element: <RecipeDetails />
        },
    ]
}

export default ProductManagementRoute;